// For non-RTK error responses
export type LegacyApiError = {
  status: number
  response: {
    error: string
    errorCode?: string
  }
}

export const isLegacyApiError = (err: unknown): err is LegacyApiError => {
  return typeof err === 'object' && err !== null && 'status' in err
}
